import { useMutation } from '@tanstack/react-query'
import loginApi from '../../../api/loginApi'
import { paths } from '../../../api/pathsApi'
import { AxiosError } from 'axios'
import { handleAxiosError } from '../../../helpers/handleAxiosError'
import { useEffect, useState } from 'react'

interface UserLogin {
  email: string
  password: string
  recaptcha_token: string
}

interface Response {
  access_token: string
  token_type: string
}

const login = async (user: UserLogin) => {
  const { data } = await loginApi.post<Response>(paths().USER.LOGIN, user)
  return data
}

export const useLogin = () => {
  const { data, mutate, error, isPending } = useMutation({
    mutationKey: ['login'],
    mutationFn: (user: UserLogin) => login(user),
  })
  const [tokenObj, setTokenObj] = useState({
    token: data && data.access_token,
    type: 'normal',
  })
  const handleLogin = (user: UserLogin) => mutate(user)

  useEffect(() => {
    if (data && data.access_token) {
      setTokenObj({
        token: data.access_token,
        type: 'normal',
      })
    }
  }, [data])

  const clearTokens = () => {
    setTokenObj({
      token: '',
      type: 'normal',
    })
  }

  return {
    token: tokenObj.token ?? '',
    handleLogin,
    isLoading: isPending,
    clearTokens,
    tokenType: tokenObj.type,
    setTokenObj,
    hasError: handleAxiosError(error as AxiosError),
  }
}
